<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <b-modal
       ref="userEditModal"
       size="xl"
       :id="id"
       :title="title"
       ok-title="Save"
       @ok="submit"
       @cancel="$emit('cancel')"
   >
      <b-card no-body>
         <b-tabs pills card>
            <b-tab title="User Data" active class="edit-user-tab">
               <b-form>
                  <b-row>
                     <b-col md="6">
                        <b-row>
                           <b-col>
                              <b-form-group label="First Name: ">
                                 <b-form-input
                                     id="edit-user__firstname"
                                     type="text"
                                     v-model="localUser.firstName"
                                     required
                                     :placeholder="localUser.firstName"
                                 ></b-form-input>
                              </b-form-group>
                           </b-col>
                           <b-col>
                              <b-form-group label="Last Name: ">
                                 <b-form-input
                                     id="edit-user__lastname"
                                     type="text"
                                     name="lastname"
                                     v-model="localUser.lastName"
                                     v-validate="'required'"
                                     :placeholder="localUser.lastName"
                                     :state="validateState('lastname')"
                                 ></b-form-input>
                              </b-form-group>
                           </b-col>
                        </b-row>

                        <b-row>
                           <b-col>
                              <b-form-group label="Company: ">
                                 <b-form-input
                                     id="edit-user__company"
                                     type="text"
                                     v-model="localUser.company"
                                     required
                                     :placeholder="localUser.company"
                                 ></b-form-input>
                              </b-form-group>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col>
                              <b-form-group label="Street: ">
                                 <b-form-input
                                     id="edit-user__street"
                                     type="text"
                                     name="street"
                                     v-model="localUser.street"
                                     :placeholder="localUser.street"
                                 ></b-form-input>
                              </b-form-group>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col>
                              <b-form-group label="Zip Code: ">
                                 <b-form-input
                                     id="edit-user__zipCode"
                                     type="text"
                                     name="zipCode"
                                     v-model="localUser.zipCode"
                                     :placeholder="localUser.zipCode"
                                 ></b-form-input>
                              </b-form-group>
                           </b-col>
                           <b-col>
                              <b-form-group label="City: ">
                                 <b-form-input
                                     id="edit-user__city"
                                     type="text"
                                     name="city"
                                     v-model="localUser.city"
                                     :placeholder="localUser.city"
                                 ></b-form-input>
                              </b-form-group>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col>
                              <b-form-group label="Country: ">
                                 <v-select id="country"
                                           :clearable="false"
                                           name="country"
                                           :value="country"
                                           @input="onSelectCountry"
                                           label="name"
                                           :options="countryList">
                                 </v-select>
                              </b-form-group>
                           </b-col>
                        </b-row>

                        <b-form-group label="Email: ">
                           <b-form-input
                               id="edit-user__email"
                               type="email"
                               name="email"
                               v-model.trim="localUser.email"
                               v-validate="'required|email'"
                               :placeholder="localUser.email"
                               :state="validateState('email')"
                           ></b-form-input>
                        </b-form-group>
                        <b-form-group label="New Password: ">
                           <b-form-input
                               id="edit-user__password"
                               type="password"
                               v-model="localUser.newPassword"
                               :placeholder="localUser.newPassword"
                           ></b-form-input>
                        </b-form-group>
                     </b-col>
                     <b-col md="6">
                        <b-row>
                           <b-col>
                              <b-form-group label="Groups: ">
                                 <b-form-group>
                                    <b-form-checkbox-group stacked v-model="localUser.roles"
                                                           :options="roleOptions"></b-form-checkbox-group>
                                 </b-form-group>
                              </b-form-group>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col>
                              <b-form-group label="Suppliers: ">
                                 <b-form-group>
                                    <v-select
                                        id="selectSupplierId"
                                        :searchable="true"
                                        :reduce="supplier => supplier.value"
                                        multiple
                                        :key="localUser.id"
                                        v-model="localUser.supplierIdList"
                                        :clearable="false"
                                        :options="supplierOptions">
                                    </v-select>
                                 </b-form-group>
                              </b-form-group>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col>
                              <b-form-group label="Shops: ">
                                 <b-form-group>
                                    <v-select
                                        id="selectCustomerSHop"
                                        :searchable="true"
                                        :reduce="shop => shop.value"
                                        multiple
                                        :key="localUser.id"
                                        v-model="localUser.externalShopCategoryId"
                                        :clearable="false"
                                        :options="customerShopOptions">
                                    </v-select>
                                 </b-form-group>
                              </b-form-group>
                           </b-col>
                        </b-row>
                     </b-col>
                  </b-row>
               </b-form>
            </b-tab>
            <b-tab title="Customer Info" class="edit-user-tab">
               <spinner v-if="!diamondLoaded"></spinner>
               <div v-else>
                  <h5 class="header--inline">Search</h5>
                  <b-row class="mb-2">
                     <b-col>
                        <v-select @input="setSelected" :value="diamondUser" :options="contacts"
                                  :filter="filterFunction">
                           <template v-slot:cell(option)="option">
                              {{ option.firstName }} {{ option.lastName }} {{ option.company.companyName }}
                           </template>
                        </v-select>
                     </b-col>
                  </b-row>
                  <b-row>
                     <b-col>
                        <div v-if="localUser.externalId && diamondUser.company">
                           <h5>Information <span
                               class="badge badge-secondary">{{ diamondUser.externalAccountType === 'DIAMOND_LIGHT' ? 'Diamong Light' : 'Diamond' }}</span>
                           </h5>
                           <b-card tag="article" class="mb-2">
                              <b-card-text>
                                 {{ diamondUser.salutation }} {{ diamondUser.firstName }}
                                 {{ diamondUser.lastName }}<br/><br/>

                                 {{ diamondUser.company.companyName }} | {{ diamondUser.company.customerNumber }}<br/>
                                 {{ diamondUser.company.street }}<br/>
                                 {{ diamondUser.company.zipCode }} {{ diamondUser.company.city }}
                              </b-card-text>
                           </b-card>
                        </div>
                     </b-col>
                  </b-row>

               </div>
            </b-tab>
         </b-tabs>
      </b-card>
   </b-modal>
</template>

<script>
// @ is an alias to /src
import {mapState, mapActions, mapGetters} from "vuex";
import ShoppingCartApi from "@shared/_api/shoppingCart";
import Spinner from "../viewsShop/components/ui/Spinner";
import SupplierOrderAPI from "@shared/_api/supplierOrder";

// TODO check if v-modal with props is the corrent approach, probably not

export default {
   name: "EditModalUser",
   props: {
      id: String,
      title: String,
      userToEdit: Object,
      roles: Array,
      customerShops: Array,
      customerShopSearchResult: null
   },
   components: {
      'spinner': Spinner
   },
   created() {
      this.fetchDiamond();
      SupplierOrderAPI.getSupplierList()
          .then(supplierList => {
             this.supplierList = supplierList;
          });
      ShoppingCartApi.getCountryList()
          .then(countryList => {
             this.countryList = countryList;
          }).finally(() => {
      });
   },
   data() {
      return {
         localUser: null,
         diamondSearchResult: null,
         countryList: [],
         supplierList: [],
      }
   },
   computed: {
      ...mapState("diamondManagement", ["diamond", "diamondLoaded"]),
      ...mapGetters("diamondManagement", ["contacts"]),
      country() {
         return this.countryList.find(item => {
            return item.id === this.localUser.countryId;
         });
      },
      roleOptions() {
         return this.roles.map(role => ({value: role.id, text: role.name}));
      },
      customerShopOptions() {
         let customerShopList = this.customerShops.filter(customerShop => customerShop.webName).map(customerShop => ({
            value: customerShop.id,
            label: customerShop.webName + " (" + customerShop.id + ") "
         }));
         return this.$_.sortBy(customerShopList, [function (o) {
            return o.label;
         }]);
      },
      supplierOptions() {
         return this.supplierList.map(supplier => ({
            value: supplier.id,
            label: supplier.name + " (" + supplier.id + ") "
         }));
      },
      diamondUser() {
         if (this.diamond && this.diamond.length > 0) {
            const diamondInfo = this.diamond.filter(user => (user.id === this.localUser.externalId && user.externalAccountType === this.localUser.externalAccountType));
            if (diamondInfo.length !== 0) {
               if (diamondInfo[0].company && diamondInfo[0].company.id) {
                  delete diamondInfo[0].company.id
               }
               return diamondInfo[0]
            }
            return {}
         }
         return {}
      }
   },
   methods: {
      ...mapActions("diamondManagement", ["fetchDiamond"]),
      onSelectCountry(country) {
         this.localUser.countryId = country.id;
      },
      validateState(ref) {
         if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.errors.has(ref)
         }
         return null
      },
      searchSelectUser(userId) {
         // TODO bug
         this.diamondSearchResult = this.diamond.filter(user => user.id === userId)[0]; // TODO error checking
      },
      setSelected(val) {
         this.localUser.externalId = val.id;
         this.localUser.externalAccountType = val.externalAccountType;
      },
      closeSearch() {
         this.diamondSearchResult = null;
      },
      acceptSearchUser() {
         this.localUser.externalId = this.diamondSearchResult.id // TODO
      },
      filterFunction(options, search) {
         let lowerCaseSearch = search.toLowerCase();
         return options.filter(option => {
            return (option.firstName && option.firstName.toLowerCase().indexOf(lowerCaseSearch) > -1) || (option.lastName && option.lastName.toLowerCase().indexOf(lowerCaseSearch) > -1) || (option.company && option.company.companyName.toLowerCase().indexOf(lowerCaseSearch) > -1);
         });
      },
      submit(bvModalEvt) {
         bvModalEvt.preventDefault();

         this.$validator.validate().then(valid => {
            if (valid) {
               this.$nextTick(() => {
                  this.$emit('ok', this.localUser);
                  this.$refs.userEditModal.hide();
               })
            }
         });
      }
   },
   watch: {
      userToEdit: {
         handler: function (val) {
            this.localUser = this.$_.cloneDeep(val);
         },
         deep: true,
         immediate: true
      }
   },
};
</script>
